<template>
  <div>
    <p class="enheader">
      <slot></slot>
    </p>
    <div v-show="color" class="line" :style="{backgroundColor: color, width: width}"></div>
    <p class="fubiao">{{ fubiaoti }}</p>
  </div>
</template>

<script>
export default {
  name: "lgg-title",
  props: {
    fubiaoti: {
      type: String,
      required: true
    },
    color: {
      type: String
    },
    width: {
      type: String,
      default: '350px'
    }
  },
}
</script>

<style scoped>
.line {
  height:20px; margin-bottom: 20px; margin-top: -25px;
}

.enheader {
  mix-blend-mode: multiply;
  font-size: 65px;
  font-weight: bold;
  line-height: 55px;
  text-shadow: gainsboro 5px 5px 5px;
}
.fubiao {
  font-size: 33px;
  font-weight: lighter;
  line-height: 50px;
}
</style>
